export type PinPukRecoveryForm = {
    first_name: string;
    last_name: string;
    email: string;
    distributor_name: string;
    product_serial_number: string;
    documents: { file: File; isLoading: boolean; error: string | null }[];
    comment: string;
    confirm_truth: boolean;
    confirm_intent: boolean;
};

export type VRMRecoveryForm = {
    first_name: string;
    last_name: string;
    email: string;
    distributor_name: string;
    gx_serial_number: string;
    vrm_portal_id: string;
    type_of_request: 'new_owner_request';
    documents: { file: File; isLoading: boolean; error: string | null }[];
    comment: string;
    confirm_truth: boolean;
    confirm_intent: boolean;
};

export enum RLAFormMode {
    PIN_PUK_RECOVERY = 'pinPukRecovery',
    VRM_ADMIN_ACCESS = 'vrmAdminAccess',
}
